import { render, staticRenderFns } from "./ReviewGallery.vue?vue&type=template&id=69e4940e"
import script from "./ReviewGallery.vue?vue&type=script&lang=js"
export * from "./ReviewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports